<template>
    <div>
        <c-search-box ref="searchbox" @enter="getList">
            <template slot="search">
                <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <c-plant
                        type="search"
                        name="plantCd"
                        v-model="searchParam.plantCd"
                        @input="getList"
                    />
                </div>
            </template>
        </c-search-box>
        <c-table
            ref="equipTable"
            title="설비별 BOM 목록"
            :columns="grid.columns"
            :data="grid.data"
            :gridHeight="grid.height"
            :selection="popupParam.type"
            rowKey="equipmentBomCd"
        >
            <!-- 버튼 영역 -->
            <template slot="table-button">
                <q-btn-group outline>
                    <!-- <c-btn label="검색" icon="search" @btnClicked="getList" /> -->
                    <c-btn label="선택" icon="check" @btnClicked="select" />
                </q-btn-group>
            </template>
        </c-table>
        <c-dialog :param="popupOptions"></c-dialog>
    </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
    name: "bom-pop",
    props: {
        popupParam: {
            type: Object,
            default: function () {
                return {
                    type: "multiple",
                    equipmentCds: [],
                    plantCd: null,
                };
            },
        },
        contentHeight: {
            type: [String, Number],
            default: function () {
                return "auto";
            },
        },
    },
    data() {
        return {
            grid: {
                columns: [
                    {
                        name: "equipmentNo",
                        field: "equipmentNo",
                        label: "설비Tag",
                        align: "center",
                        sortable: true,
                    },
                    {
                        name: "equipmentName",
                        field: "equipmentName",
                        label: "설비명",
                        align: "center",
                        sortable: true,
                    },
                    {
                        name: "materialNo",
                        field: "materialNo",
                        label: "자재번호",
                        align: "center",
                        sortable: false,
                    },
                    {
                        name: "equipmentBomName",
                        field: "equipmentBomName",
                        label: "자재명",
                        align: "left",
                        sortable: false,
                    },
                ],
                data: [],
                height: "450px",
            },
            searchParam: {
                plantCd: null,
                equipmentBomTypeCd: "EBTC000002",
                equipmentCds: [],
            },
            popupOptions: {
                target: null,
                title: "",
                visible: false,
                top: "",
                param: {},
                closeCallback: null,
            },
            editable: true,
            listUrl: "",
        };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
        Object.assign(this.$data, this.$options.data());
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    watch: {
        contentHeight() {
            let height =
                this.contentHeight -
                this.$refs["searchbox"].$el.offsetHeight -
                50;
            if (height < 400) {
                height = 450;
            }
            this.grid.height = height + "px";
        },
    },
    methods: {
        init() {
            // role setting
            this.editable = this.$route.meta.editable;
            // url setting
            this.listUrl = selectConfig.mdm.bom.list.url;
            if (this.popupParam.plantCd) {
                this.searchParam.plantCd = this.popupParam.plantCd;
            }
            if (this.popupParam.supplantMaterialCd) {
                this.searchParam.supplantMaterialCd =
                    this.popupParam.supplantMaterialCd;
            }
            if (
                this.popupParam.equipmentCds &&
                this.popupParam.equipmentCds.length > 0
            ) {
                this.searchParam.equipmentCds = this.$_.map(
                    this.popupParam.equipmentCds,
                    "equipmentCd",
                );
            }
            // list setting
            this.getList();
        },
        getList() {
            this.$http.url = this.listUrl;
            this.$http.type = "GET";
            this.$http.param = this.searchParam;
            this.$http.request((_result) => {
                this.grid.data = _result.data;
            });
        },
        select() {
            let selectData = this.$refs["equipTable"].selected;
            if (!selectData || selectData.length === 0) {
                window.getApp.$emit("ALERT", {
                    title: "안내", // 안내
                    message: "자재를 선택하세요.", // 정비자재를 선택하세요.
                    type: "warning", // success / info / warning / error
                });
            } else {
                this.$emit("closePopup", selectData);
            }
        },
    },
};
</script>
